import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { fadeIn, fadeOut } from 'src/app/animations';
import { DataGroup } from 'src/app/shared/enum/data-group';
import { ModalAlterarDadosUsuarioComponent } from 'src/app/shared/modals/modal-alterar-dados-usuario/modal-alterar-dados-usuario.component';
import { ModalImagemPerfilComponent } from 'src/app/shared/modals/modal-imagem-perfil/modal-imagem-perfil.component';
import { DataService } from 'src/app/shared/services/data.service';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SolicitationService } from '../../../services/usuario/solicitation.service';
@Component({
  selector: 'app-dados-cadastrais',
  templateUrl: './dados-cadastrais.component.html',
  styleUrls: ['./dados-cadastrais.component.css'],
  animations: [fadeIn, fadeOut]
})
export class DadosCadastraisComponent {
  imagem: any;
  userDataFilter: any;
  todaysDate: any = new Date().toJSON().split('T')[0];
  genderList: any[] = [{ desc: "Masculino" }, { desc: "Feminino" }];
  maritalStatusList: any[] = [{ desc: "Solteiro" }, { desc: "Casado" }, { desc: "Separado" }, { desc: "Divorciado" }, { desc: "Viúvo" }];
  formDataEdit: boolean = false;
  formBankEdit: boolean = false;
  formContactEdit: boolean = false;
  formPasswordEdit: boolean = false;
  bankAddDisable: boolean = false;
  dependent: boolean = false;
  lastModificationDate!: Date;
  dataSolicitationDisable: boolean = true;
  contactSolicitationDisable: boolean = true;
  passwordSolicitationDisable: boolean = true;
  banks: any;
  baseContext: any;
  primitiveCep!: string;
  primitiveEmail: any;
  primitivePersonalPhone: any;
  cpf!: string;
  url: string = environment.portalApi;
  beneficiaries!: any[];
  loading: boolean = false;
  textoAviso = "Atenção Participante! Faça aqui sua declaração de pessoa politicamente exposta - PPE";
  formGroup: FormGroup = new FormGroup({
    personCpf: new FormControl(null),
    titular: new FormControl(null)
  });
  formData: FormGroup = new FormGroup({
    holder: new FormControl(null, [Validators.required]),
    nationality: new FormControl(null, [Validators.required]),
    birthDate: new FormControl(null, [Validators.required, this.formValidator.isValidDateToday]),
    cpf: new FormControl({ value: null, disabled: true }, [Validators.required]),
    father: new FormControl(null),
    gender: new FormControl({ value: null, disabled: true }, [Validators.required]),
    maritalStatus: new FormControl({ value: null, disabled: true }, [Validators.required]),
    mother: new FormControl(null, [Validators.required]),
    name: new FormControl(null, [Validators.required]),
    registration: new FormControl({ value: null, disabled: true }),
    rg: new FormControl(null, [Validators.required]),
    rgDate: new FormControl(null, [Validators.required, this.formValidator.isValidDateToday]),
    rgOrgaoExpeditor: new FormControl(null, [Validators.required]),
    rgUfOrgaoExpeditor: new FormControl(null, [Validators.required])
  }, this.formValidator.dateLessThan('birthDate', 'rgDate', { 'rgDate': true }));
  formContact: FormGroup = new FormGroup({
    address: new FormControl(null, [Validators.required]),
    cep: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    comercialPhone: new FormControl(null),
    complement: new FormControl(null),
    country: new FormControl(null, [Validators.required]),
    district: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    number: new FormControl(null, [Validators.required]),
    personalPhone: new FormControl(null),
    postalCode: new FormControl(null),
    replicateDependant: new FormControl(false),
    registration: new FormControl(null),
    secondaryEmail: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    state: new FormControl(null, [Validators.required])
  });
  formPasword: FormGroup = new FormGroup({
    senhaAntiga: new FormControl(null, [Validators.required]),
    novaSenha: new FormControl(null, [Validators.required]),
    confirmaSenha: new FormControl(null, [Validators.required]),
  }, {
    validators: passwordMatchValidator('novaSenha', 'confirmaSenha')
  });

  IsPersonate: boolean = false;

  constructor(private data: DataService, private formValidator: FormValidator, private modalService: NgbModal, private solicitationService: SolicitationService,
    private tokenService: TokenService, private userService: UsuarioService, private bsLocaleService: BsLocaleService, private toast: ToastrService) {

      this.userService.getProfiles().subscribe({
        next: (res: any) => {
          if(res.isPersonate){
            this.IsPersonate = true

          }
        },
        error: (err: any) => {
        }
      });

    this.userService.getUserProfilePicture().subscribe((data: any) => {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imagem = reader.result;
      }, false);
      if (data) {
        reader.readAsDataURL(data);
      }
    });
    this.desabilitarCampos();
    this.bsLocaleService.use('pt-br');
    let user = this.tokenService.getActiveUser();
    if (user) this.cpf = user.cpf;
    if (!user || (!user.socialSecurityProfile && user.healthProfile?.statusId == 99)) this.dependent = true;
    this.userService.getBeneficiaries().subscribe((res: any) => {
      this.beneficiaries = res;
      this.formGroup.get('personCpf')?.setValue(res[0].id);
      this.updateEntries();
      this.formContact.disable();
      this.formPasword.disable();
    });
  }
  uploadImg() {
    this.modalService.open(ModalImagemPerfilComponent, { size: 'lg', centered: true });
  }
  dataChanged() {
    this.dataSolicitationDisable = false;
  }
  onlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (!(charCode >= 65 && charCode <= 90) && // Letras maiúsculas A-Z
        !(charCode >= 97 && charCode <= 122) && // Letras minúsculas a-z
        !(charCode === 32)) { // Permite espaço
      event.preventDefault();
    }
  }
  
  chagePassword() {
    this.userService.changePassword({ UserCpf: this.tokenService.getActiveUser()['cpf'], OldPassword: this.formPasword.get('senhaAntiga')?.value, NewPassword: this.formPasword.get('novaSenha')?.value }).subscribe({
      next: (res: any) => {
        this.toast.success('Senha alterada com sucesso!');
        this.updatePasswordEdit();
        this.formPasword.reset();
      },
      error: (err: any) => {
        this.toast.error(err.description);
      }
    })
  }
  updateData() {
    this.validateAllFormFields(this.formData);
    if (this.formData.valid) {
     
      const modalRef = this.modalService.open(ModalAlterarDadosUsuarioComponent, { size: 'lg', centered: true });
      modalRef.componentInstance.formUserData = this.formData.value;
      // desenvolver para pegar o usuário loggado
      modalRef.componentInstance.beneficiaryCpf = this.formGroup.get('personCpf')?.value;
      modalRef.result.then(res => {
        if (res === 'success') {
          this.updateDataEditToModal();
          //  const modalOk = this.modalService.open(SolicitationOkModalComponent, { centered: true });
          //  modalOk.componentInstance.route = "minhas-solicitacoes-cadastrais";
          //  modalOk.componentInstance.description = "de Alteração Cadastral";
          Swal.fire({
            title: 'Solicitação cadastral encaminhada para análise!',
            text: '',
            icon: 'success',
            showConfirmButton: false,
          }).then((result: any) => {
            this.updateDataEdit(false);
          });
        }
      })
    }
    //  this.validateAllFormFields(this.formData);
    // if (this.formData.valid) {
    //      const modalRef = this.modalService.open(AlterUserDataModalComponent, { size: 'lg', centered: true });
    //      modalRef.componentInstance.formUserData = this.formData.value;
    //      modalRef.componentInstance.beneficiaryCpf = this.userDataFilter.personCpf;
    //      modalRef.result.then(res => {
    //          if (res === 'success') {
    //              this.updateDataEditToModal();
    //              const modalOk = this.modalService.open(SolicitationOkModalComponent, { centered: true });
    //              modalOk.componentInstance.route = "minhas-solicitacoes-cadastrais";
    //              modalOk.componentInstance.description = "de Alteração Cadastral";
    //          }
    //      })
    // }
  };




  updateDataEditToModal() {
    this.formDataEdit = !this.formDataEdit;
    this.dataSolicitationDisable = true;
    if (!this.formDataEdit) {
      this.desvalidateAllFormFields(this.formData);
      this.updateEntries();
    }
  };
  tabClicada(event: any) {
    if (event.index == 1) {
      this.updateDataEdit(false);
    } else if (this.formContactEdit == true && event.index == 0) {
      this.updateContactEdit();
    }
  }
  desabilitarCampos() {
    Object.keys(this.formData.controls).forEach(controlName => {
      this.formData.get(controlName)?.disable();
    });
  }
  updateDataEdit(edit: boolean) {
    //this.formDataEdit = !this.formDataEdit;
    this.formDataEdit = this.formDataEdit == undefined ? false : edit;
    this.formData.get('gender')?.disable();
    this.formData.get('maritalStatus')?.disable();
    if (!this.formDataEdit) {
      this.desvalidateAllFormFields(this.formData);
      this.updateEntries();
    } else {
      this.formData.enable();
      this.formData.get('registration')?.disable();
      this.formData.get('cpf')?.disable();
      this.formData.get('gender')?.enable();
      this.formData.get('maritalStatus')?.enable();
    }
  };
  rgChanged() {
    this.formData.get('rgDate')?.setValue(null);
    this.formData.get('rgOrgaoExpeditor')?.setValue(null);
    this.formData.get('rgUfOrgaoExpeditor')?.setValue(null);
  };
  inputChanged() {
    this.contactSolicitationDisable = false;
    this.dataSolicitationDisable = false;
  }
  desvalidateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: any) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched();
      } else if (control instanceof FormGroup) {
        this.desvalidateAllFormFields(control);
      }
    });
  };

  oldNumber: any;
  oldEmail: any;

  updateEntries() {
    if (!this.beneficiaries) return;
    let titular = this.beneficiaries.filter(a => a.id == this.formGroup.value.personCpf)[0].titular;
    this.formGroup.get('titular')?.setValue(titular);
    // TODO: Review this
    if (this.formDataEdit === undefined) {
      this.resetFieldsOnChange(this.formGroup.get("personCpf")?.value);
    }
    this.userService.getLastUserDataModification(this.formGroup.get("personCpf")?.value).subscribe((res: any) => {
      this.lastModificationDate = res;
    });
    this.userService.getUser(this.formGroup.get("personCpf")?.value).subscribe((res: any) => {
      this.oldNumber = res.contactResponse.personalPhone
      this.oldEmail = res.contactResponse.email


      this.formData.patchValue(res.userDataResponse);
      this.formData.get('holder')?.patchValue(this.formGroup.get('titular')?.value);
      if (res.userDataResponse.birthDate) {
        const birth = moment(res.userDataResponse.birthDate).format('YYYY-MM-DD');
        // const birth = moment(res.userDataResponse.birthDate).format('DD-MM-YYYY');
        this.formData.get('birthDate')?.setValue(birth);
      }
      if (res.userDataResponse.rgDate) {
        let rgDate = moment(res.userDataResponse.rgDate).format('YYYY-MM-DD');
        this.formData.get('rgDate')?.patchValue(rgDate);
      }
      this.banks = res.bankResponse;
      this.formContact.patchValue(res.contactResponse);
      this.formContact.controls['registration'].setValue(res.userDataResponse.registration);
      this.primitiveEmail = res.contactResponse.email;
      this.primitivePersonalPhone = res.contactResponse.personalPhone;
      this.primitiveCep = res.contactResponse.cep;
    });
  };
  contactChanged() {
    this.contactSolicitationDisable = false;
  }
  updateContactEdit() {
    this.desvalidateAllFormFields(this.formContact);
    this.formContact.enable();
    this.formContactEdit = !this.formContactEdit;
    if (!this.formContactEdit) {
      // this.desvalidateAllFormFields(this.formContact);            
    }
  };
  updatePasswordEdit() {
    this.formPasswordEdit = !this.formPasswordEdit;
    if (this.formPasswordEdit) {
      this.formPasword.enable();
    } else {
      this.formPasword.disable();
      this.formPasword.reset();
      this.formPasword.get('novaSenha')?.untouched;
      this.formPasword.get('senhaAntiga')?.untouched;
      this.formPasword.get('confirmaSenha')?.untouched;
    }
  };
  phoneFocus() {
    //this.contactSolicitationDisable = true;
  }
  cepChanged() {
    if (this.formContact.get('cep')?.value.length == 8) {
      this.contactChanged();
      // this.formContact.get('number')?.patchValue(null);
      // this.formContact.get('complement')?.patchValue(null);
      this.solicitationService.getZipCodeParams(this.formContact.get('cep')?.value)
        .subscribe((res: any) => {
          if (res.localidade) {
            if (res.logradouro) {
              this.formContact.get('address')?.setValue(res.logradouro.toUpperCase());
              this.formContact.get('address')?.disable();
            } else {
              this.formContact.get('address')?.setValue(null);
              this.formContact.get('address')?.enable();
            }
            this.formContact.get('city')?.setValue(res.localidade.toUpperCase());
            this.formContact.get('city')?.disable();
            this.formContact.get('state')?.setValue(res.uf.toUpperCase());
            this.formContact.get('state')?.disable();
            if (res.bairro) {
              this.formContact.get('district')?.setValue(res.bairro.toUpperCase());
              this.formContact.get('district')?.disable();
            } else {
              this.formContact.get('district')?.setValue(null);
              this.formContact.get('district')?.enable();
            }
            this.formContact.get('country')?.setValue('BRASIL');
            this.formContact.get('country')?.disable();
            this.formContact.updateValueAndValidity();
          } else {
            this.formContact.get('cep')?.setErrors({ 'incorrect': true });
            this.formContact.get('address')?.setValue(null);
            this.formContact.get('address')?.enable();
            this.formContact.get('city')?.setValue(null);
            // this.formContact.get('city')?.enable();
            this.formContact.get('state')?.setValue(null);
            // this.formContact.get('state')?.enable();
            this.formContact.get('district')?.setValue(null);
            this.formContact.get('district')?.enable();
            this.formContact.get('country')?.setValue('BRASIL');
            // this.formContact.get('country')?.enable();
          }
        });
    } else {
      this.formContact.get('address')?.setValue(null);
      this.formContact.get('city')?.setValue(null);
      this.formContact.get('district')?.setValue(null);
      this.formContact.get('state')?.setValue(null);
    }
  }

  codigoDigitado: string = '';
  codigoReenviado = false;

  updateContact() {
    this.codigoReenviado = false;
    this.validateAllFormFields(this.formContact);

    if(this.IsPersonate){
      this.atualizarDados();
      return
    }

    if (!this.formContact.valid) {
        this.toast.error('Preencha todos os campos obrigatórios!');
        return;
    }

    const newPhone = this.formContact.get('personalPhone')?.value;
    const newEmail = this.formContact.get('email')?.value;
    let verificationType = '';

    if (newPhone !== this.oldNumber && newEmail !== this.oldEmail) {
        verificationType = 'ambos';
    } else if (newPhone !== this.oldNumber) {
        verificationType = 'email';
    } else if (newEmail !== this.oldEmail) {
        verificationType = 'phone';
    }

    if (verificationType) {
        let storage = localStorage.getItem('user-token-key-des');
        let nome = storage ? JSON.parse(storage).name : '';

        if (verificationType === 'email' || verificationType === 'ambos') {
            this.solicitarCodigoEmail({ name: nome, email: this.oldEmail });
        }
        if (verificationType === 'phone' || verificationType === 'ambos') {
            this.solicitarCodigoNumero({ name: nome, phone: this.oldNumber });
        }

        let contador = 60;
        let isLoading = false; 

        Swal.fire({
            title: `Confirme sua identidade`,
            html: verificationType === 'ambos' 
                ? `<p>Enviamos um código para seu e-mail e telefone. Digite ambos para continuar.</p>
                   <input type="text" id="swal-input-email" class="swal2-input custom-input" placeholder="Código do e-mail" maxlength="4" >
                   <input type="text" id="swal-input-phone" class="swal2-input custom-input" placeholder="Código do telefone" maxlength="4" >`
                : `<p>Enviamos um código para seu ${verificationType === 'email' ? 'e-mail' : 'telefone'}. Digite abaixo para continuar.</p>
                   <input type="text"  id="swal-input-code" class="swal2-input custom-input" placeholder="Digite o código recebido" maxlength="4">`,
            icon: 'info',
            showDenyButton: true,
            denyButtonText: `Reenviar código em ${contador}s`,
            confirmButtonText: 'Validar',
            allowOutsideClick: true,
            allowEscapeKey: true,

            customClass: {
                confirmButton: 'button-confirm',
                denyButton: 'button-deny'
            },

            preConfirm: async () => {
                if (isLoading) return false;



                if (verificationType === 'ambos') {
                    let emailCode = (document.getElementById('swal-input-email') as HTMLInputElement)?.value;
                    let phoneCode = (document.getElementById('swal-input-phone') as HTMLInputElement)?.value;

                    if (emailCode.length === 4 && phoneCode.length === 4) {
                      setTimeout(() => {
                        Swal.showLoading(); 
                      }, 100);
                        try {
                          
                          await this.validaOsDoisCodigos({ code: emailCode }, { code: phoneCode });

                          return false;
                        } catch (error) {
                            Swal.showValidationMessage('Erro ao validar os códigos. Tente novamente.');
                            isLoading = false;
                            return false;
                        }
                    } else {
                        Swal.showValidationMessage('Ambos os códigos precisam ter 4 dígitos!');
                        isLoading = false;
                        return false;
                    }
                } else {

                  this.loading = true
                    let singleCode = (document.getElementById('swal-input-code') as HTMLInputElement)?.value;
                    if (singleCode.length === 4) {
                      setTimeout(() => {
                        Swal.showLoading(); 
                      }, 100);
                        try {
                            if (verificationType === 'email') {
                                await this.enviaCodeEmail({ code: singleCode });
                            } else {
                                await this.enviaCodeNumber({ code: singleCode });
                            }
                        } catch (error) {
                            Swal.showValidationMessage('Erro ao validar o código. Tente novamente.');
                            isLoading = false;
                            return false;
                        }
                    } else {
                        Swal.showValidationMessage('O código precisa ter 4 dígitos!');
                        isLoading = false;
                        return false;
                    }
                }

                return false
            },

            preDeny: () => {
                if (this.codigoReenviado) {
                    if (verificationType === 'email' || verificationType === 'ambos') {
                        this.solicitarCodigoEmail({ name: nome, email: this.oldEmail });
                    }
                    if (verificationType === 'phone' || verificationType === 'ambos') {
                        this.solicitarCodigoNumero({ name: nome, phone: this.oldNumber });
                    }

                    const denyButton = document.querySelector('.swal2-deny') as HTMLButtonElement;
                    if (denyButton) {
                        denyButton.setAttribute('disabled', 'true');
                        denyButton.textContent = "Código reenviado!";
                    }

                    this.codigoReenviado = false;
                }

                return false;
            },

            didOpen: () => {
                const denyButton = document.querySelector('.swal2-deny') as HTMLButtonElement;
                if (denyButton) {
                    denyButton.disabled = true;

                    const interval = setInterval(() => {
                        if (contador > 0) {
                            denyButton.textContent = `Reenviar código em ${contador}s`;
                            contador--;
                        } else {
                            clearInterval(interval);
                            denyButton.textContent = "Reenviar código";
                            this.codigoReenviado = true;
                            denyButton.disabled = false;
                        }
                    }, 1000);
                }
            }
        });
    } else {
        this.atualizarDados();
    }
}


async validaOsDoisCodigos(bodyEmail: any, bodyPhone: any) {
  try {
    // Valida o código do email
    const emailValid = await this.solicitationService.validateEmailChangedcode(bodyEmail).toPromise();

    if (emailValid !== true) {
      setTimeout(() => {
        Swal.fire({
          title: 'Código de email inválido!',
          text: 'Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'button-confirm'
          }
        });
      }, 100);
      return;
    }

    // Valida o código do telefone
    const phoneValid = await this.solicitationService.validatePhoneChangedcode(bodyPhone).toPromise();

    if (phoneValid !== true) {
      setTimeout(() => {
        Swal.fire({
          title: 'Código de telefone inválido!',
          text: 'Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'button-confirm'
          }
        });
      }, 100);
      return;
    }

    // Atualiza os dados
    await this.atualizarDados();

  } catch (error) {
    if((error as any).status){
      setTimeout(() => {
        Swal.fire({
          title: 'Código incorreto!',
          text: 'Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'button-confirm'
          }
        });
      }, 100);

    }
  }
}


    private showError(message: string) {
      Swal.fire({
        title: message,
        icon: 'error',
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'button-confirm'
        }
      });
    }

    private handleError(error: any) {
      if (error.status === 500) {
        this.showError('Ocorreu um erro com a validação. Por favor, tente novamente.');
      } else {
        Swal.fire({
          title: 'Erro!',
          text: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'button-confirm'
          }
        });
      }
    }


  atualizarDados() {
    this.loading = true;
    let changeContactData = {
      ...this.formContact.getRawValue(),
      beneficiaryCpf: this.formGroup.get('personCpf')?.value,
      dataGroupRequest: DataGroup.Contact,
      titular: this.formGroup.get('titular')?.value,
    };
  
    this.solicitationService.changeUserData(changeContactData).subscribe({
      next: () => {
        this.loading = false;
        this.updateContactEdit();
        Swal.fire({
          title: 'Alterações realizadas com Sucesso!',
          text: '',
          icon: 'success',
          showConfirmButton: false,
        });
      },
      error: () => {
        this.loading = false;
      }
    });
  }
  
  enviaCodeEmail(body: any) {
    this.solicitationService.validateEmailChangedcode(body).subscribe(
      (data: any) => {
        if (data === true) {
          this.atualizarDados();
        } else {
          Swal.fire({
            title: 'Código inválido!',
            text: 'Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        }
      },
      (error) => {
        if (error.status === 500) {
          Swal.fire({
            title: 'Código inválido!',
            text: 'Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        } else {
          Swal.fire({
            title: 'Erro!',
            text: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        }
      }
    );
  }
  
  
  enviaCodeNumber(body: any) {
    this.solicitationService.validatePhoneChangedcode(body).subscribe(
      (data: any) => {
        if (data === true) {
          this.atualizarDados();
        } else {
          Swal.fire({
            title: 'Código inválido!',
            text: 'Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        }
      },
      (error) => {
        if (error.status === 500) {
          Swal.fire({
            title: 'Código inválido!',
            text: 'Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        } else {
          Swal.fire({
            title: 'Erro!',
            text: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass:{
              confirmButton: 'button-confirm'
            }
          });
        }
      }
    );
  }
  

  solicitarCodigoEmail(body: any) {
    this.solicitationService.getEmailChangedcode(body).subscribe((data: any) =>{
    })
  }

  solicitarCodigoNumero(body: any){
    this.solicitationService.getNumberChangedcode(body).subscribe((data: any) =>{
    })
  }


  alteraDadoUsuario() {
    this.updateEntries();
    this.updateDataEdit(false);
  }
  resetFieldsOnChange(id: number) {
    const self = this;
    self.data = {
      filter: { personCpf: id },
      refs: self,
      list: null,
      method: this.updateEntries
    };
    this.data = self.data;
    this.baseContext.formDataEdit = false;
    this.baseContext.formContactEdit = false;
    this.updateDataEdit(false);
  };
  //VALIDADORES
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  };


}



export function passwordMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const controlValue = control.get(controlName)?.value;
    const matchingControlValue = control.get(matchingControlName)?.value;
    if (controlValue !== matchingControlValue) {
      return { 'passwordMatch': true };
    } else {
      return null;
    }
  };
}